/* global Eht */
import { Office } from '@bag'
import { validUtil } from '@/core'

const util = {
  title(opt, tar) {
    if (opt.title && Array.isArray(opt.title)) {
      const nodes = opt.title
        .map(t => {
          return `<div class="file-row__titles">${t}</div>`
        })
        .join('')
      return (nodes && $(nodes)) || ''
    }
  },
}

class OfficeTool {
  constructor(opt) {
    const def = {
      title: [], // 设置标题
      selector: null, // 模板node id
      valueCodeField: 'f_code', // code 值对应字段
      labelCodeField: 'f_name', // code 文字对应字段
      loadInit: true, // 是否加载
      codeContent: Eht.DataCode, // code 源数据
    }
    this.opt = Object.assign(def, opt)
    this.$el = $(this.opt.selector)
    this.init()
  }

  init() {
    const office = (this.office = new Office(this.opt))
    this.unit = office.unit
    this.title = util.title(this.opt, this)
    this.title && this.unit.prepend(this.title)
    this.$el.addClass('lt-office').append(this.unit)
    this.objs = {}
    this.items = office.objs
    Object.entries(office.objs).map(x => {
      this.objs[x[0]] = x[1].item
    })
  }

  bindValid(data) {
    // 不建议外部调用
    const valid = data
    const objs = this.office.objs
    if (valid) {
      for (const key in valid) {
        if (objs[key]) {
          objs[key].change(obj => {
            this.checkOneValid(obj, valid[key])
          })
          objs[key].keyup(obj => {
            this.checkOneValid(obj, valid[key])
          })
        }
      }
    }
  }

  checkOneValid(obj, vld) {
    const { rtn, text } = validUtil.getValidResult(obj, vld)
    this.touchValid(Boolean(rtn), text, obj)
  }

  fill(data, ...res) {
    this.loadData(data, ...res)
  }

  clear(...res) {
    this.office.clearData(...res)
    const object = this.office.objs
    for (const key in object) {
      const element = object[key]
      element.unit.find('.lt-tooltip').remove()
      element.unit.removeClass('is-error')
    }
  }

  getData() {
    return this.office.getData()
  }

  checkValid() {
    let res = true
    const valid = this.valid
    const objs = this.office.objs
    if (valid) {
      for (const key in valid) {
        let nsk = true
        let textBuffer = ''
        if (objs[key]) {
          const vld = valid[key]
          const { rtn, text } = validUtil.getValidResult(objs[key], vld)
          nsk = rtn
          textBuffer = text
        }
        res = res & nsk
        this.touchValid(Boolean(nsk), textBuffer, objs[key])
      }
    }
    return Boolean(res)
  }

  touchValid(res, text, obj) {
    if (!obj.unit) return
    obj.unit.find('.lt-tooltip').remove()
    if (!res) {
      obj.unit.addClass('is-error')
      obj.unit.append(`<div class="lt-tooltip">${text}</div>`)
    } else {
      obj.unit.removeClass('is-error')
    }
  }

  loadData(args, ...res) {
    if (this._object == null) {
      this._object = args
    }
    const office = this.office
    if (args) {
      if ($.type(args) === 'object') {
        this.data = args
      } else if ($.type(args) === 'array') {
        this.data = args[0]
      } else if ($.type(args) === 'function') {
        this._loadData = args
        if (this.loadResp == null) {
          this.loadResp = new Eht.Responder()
          var error = this.loadResp.error
          this.loadResp.success = (data, textStatus, jqXHR) => {
            this.loadData(data, ...res)
            if (this._loadComplete != null) {
              this._loadComplete(data)
            }
          }
          this.loadResp.error = function (data, textStatus, jqXHR) {
            error(data, textStatus, jqXHR)
          }
        }
        if (this.opt.loadInit) {
          this._loadData(this.loadResp)
        }
        return
      }
      if ($.type(this.data) === 'object') {
        office.fill(this.data, ...res)
      }
    }
  }

  loadComplete(func) {
    this._loadComplete = func
  }

  refresh() {
    this.opt.loadInit = true
    this.loadData(this._object)
  }

  disabled(...res) {
    this.office.disabledItem(...res)
  }

  enabled(...res) {
    this.office.enabledItem(...res)
  }

  viewable(...res) {
    this.office.viewable(...res)
  }

  editable(...res) {
    this.office.editable(...res)
  }

  hideItem(...res) {
    this.office.hideItem(...res)
  }

  showItem(...res) {
    this.office.showItem(...res)
  }

  hideSection(...res) {
    this.office.hideSection(...res)
  }

  showSection(...res) {
    this.office.showSection(...res)
  }

  reset(...res) {
    this.office.reset(...res)
  }

  set valid(data) {
    this.opt.valid = data
    this.bindValid(data)
  }

  get valid() {
    return this.opt.valid
  }
}

Eht.OfficeTool = OfficeTool

export default OfficeTool
